export const GRID_CONTAINER_CONFIG = {
  mb: 4,
  xs: 12,
  columnSpacing: 8,
  rowSpacing: 1
} as const;

export const GRID_COLUMN_CONFIG = {
  xs: 12,
  md: 6,
  lg: 4
} as const;
